// Itens do menu lateral e a permissao de cada um (ver shared/permissions.js).
// A mesma lista decide para onde vai quem cai numa tela sem acesso: a primeira
// que o perfil pode abrir.

export const PRIMARY_NAVIGATION = [
  {
    name: "Dashboard",
    path: "/cockpit",
    icon: "fi-rr-chart-pie-alt",
    permission: "dashboard.view",
  },
  {
    name: "Curso",
    path: "/curso",
    icon: "fi-rr-book-open-cover",
    permission: "course.list",
  },
  {
    name: "Turmas",
    path: "/turmas",
    icon: "fi-rr-users-alt",
    permission: "groups.list",
  },
  {
    name: "Agenda",
    path: "/agenda",
    icon: "fi-rr-calendar-clock",
    permission: "agenda.list",
  },
  {
    name: "Usuários",
    icon: "fi-rr-user-gear",
    path: "/usuarios",
    permission: { superAdmin: true },
  },
  {
    name: "Perfis e permissões",
    icon: "fi-rr-shield-check",
    path: "/perfis",
    permission: { superAdmin: true },
  },
  {
    name: "Alunos",
    icon: "fi-rr-graduation-cap",
    path: "/alunos",
    permission: "customers.list",
  },
  {
    name: "Alunos sem professor",
    icon: "fi-rr-book-open-reader",
    path: "/alunos-sem-professor",
    permission: "customers.list",
  },
  {
    name: "Professores",
    icon: "fi-rr-chalkboard-user",
    path: "/professores",
    permission: "partners.list",
  },
  {
    name: "Financeiro",
    path: "/pagamentos",
    icon: "fi-rr-wallet",
    permission: "finance.list",
  },
  {
    name: "Monitoramento",
    path: "/monitoramento",
    icon: "fi-rr-pulse",
    permission: "monitoring.list",
  },
];

export const SECONDARY_NAVIGATION = [
  {
    name: "Comunicação",
    path: "/comunicacao",
    icon: "fi-rr-megaphone",
    permission: "communications.list",
  },
  // Card 17trt6jbffe: chat. O numero e o total de mensagens do suporte
  // ainda nao lidas pelo time.
  {
    name: "Mensagens",
    path: "/mensagens",
    icon: "fi-rr-comments",
    permission: "messages.list",
    countKey: "supportUnread",
  },
  // Card 86akqxu0h.
  {
    name: "Formulários",
    path: "/formularios",
    icon: "fi-rr-clipboard-list-check",
    permission: "surveys.list",
  },
  // Card 86akj8q08.
  {
    name: "Planos de estudo",
    path: "/planos-de-estudo",
    icon: "fi-rr-book-alt",
    permission: ["studyPlans.list", "studyPlans.grade"],
  },
  // Card 17trt6jfkw8.
  {
    name: "Certificados",
    path: "/certificados",
    icon: "fi-rr-diploma",
    permission: ["certificates.list", "certificates.preview"],
  },
  // Card 17trt6jd8uu.
  {
    name: "Pitch Coins",
    path: "/pitch-coins",
    icon: "fi-rr-coins",
    permission: ["coins.view", "coins.adjust"],
  },
  // Card 17trt6jcyfb.
  {
    name: "Exercícios",
    path: "/exercicios",
    icon: "fi-rr-edit",
    permission: "exercises.list",
  },
];
